export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', (error) => reject(error));
    img.src = url;
  });

// mimeType - keeps the uploaded photo in whatever format it came in
// (PNG stays PNG so transparency survives, instead of everything being
// silently forced through JPEG). Canvas only reliably encodes
// png/jpeg/webp, so anything else (gif, heic, svg...) falls back to png
// rather than mangling it.
const CANVAS_SUPPORTED_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

export const getCroppedImg = async (imageSrc, pixelCrop, mimeType = 'image/jpeg') => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  const outputType = CANVAS_SUPPORTED_TYPES.includes(mimeType) ? mimeType : 'image/png';
  return canvas.toDataURL(outputType);
};

// File extension to save the upload under, matching the format actually
// produced above - so a PNG upload doesn't end up saved as "photo.jpg".
// Pass the *output* blob's type (post getCroppedImg), not the original
// upload's type - they can differ for a format canvas can't encode
// (gif/heic/svg...), which getCroppedImg silently falls back to PNG for.
export const extensionForMime = (mimeType) => {
  switch (mimeType) {
    case 'image/webp': return 'webp';
    case 'image/jpeg': return 'jpg';
    case 'image/png':
    default: return 'png';
  }
};

// Supabase Storage's upload() wants a File/Blob, not a base64 data URL -
// converts the cropper's output into one so it can be uploaded directly.
export const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(',');
  const mimeMatch = header.match(/data:(.*?);base64/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
};
